import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Twitter, Facebook } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-950 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-gradient-to-br from-teal-400 to-cyan-500 rounded-lg"></div>
              <span className="text-xl font-bold text-white">
                Integral<span className="text-teal-400">Tech</span>
              </span>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed">
              Solutions technologiques innovantes pour propulser votre entreprise vers l'avenir numérique.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors">
                <Linkedin size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors">
                <Twitter size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors">
                <Facebook size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Liens Rapides</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-teal-400 transition-colors">Accueil</Link>
              </li>
              <li>
                <Link to="/services" className="text-sm hover:text-teal-400 transition-colors">Services</Link>
              </li>
              <li>
                <Link to="/blog" className="text-sm hover:text-teal-400 transition-colors">Blog</Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm hover:text-teal-400 transition-colors">Contact</Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4">Services</h3>
            <ul className="space-y-2">
              <li className="text-sm hover:text-teal-400 transition-colors cursor-pointer">Intégration IT</li>
              <li className="text-sm hover:text-teal-400 transition-colors cursor-pointer">Cloud Computing</li>
              <li className="text-sm hover:text-teal-400 transition-colors cursor-pointer">Cybersécurité</li>
              <li className="text-sm hover:text-teal-400 transition-colors cursor-pointer">Conseil IT</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="text-teal-400 mt-1 flex-shrink-0" />
                <span className="text-sm">Ouagadougou, Burkina Faso</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone size={18} className="text-teal-400 flex-shrink-0" />
                <span className="text-sm">+226 70 22 85 78</span>
              </li>
              <li className="flex items-center space-x-3">
                <Mail size={18} className="text-teal-400 flex-shrink-0" />
                <span className="text-sm">contact@integraltech.bf</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-12 pt-8 text-center">
          <p className="text-sm text-gray-400">
            © {currentYear} IntegralTech. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;